import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';
import { receiveError } from '../../../../store/actions/notificationAction';
import { stopUpdate } from '../../../../store/actions/managedExportRightSideAction';

import pickupOrderRemote from '../../../../api/pickupOrderRemote';

import DooAwbListContainer from './dropOffOrderAwbsList/DooAwbListContainer';
import SecurityDetailsContainer from './securityDetails/SecurityDetailsContainer';
import TruckerRecordInfoContainer from './truckerRecordInfo/TruckerRecordInfoContainer';

import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import PickupOrderGha from '../../../../models/PickupOrderGha';

import { PO_SCHEMA_GHA } from '../../../../utils/pickupOrder';

interface ManagedExportRightSideContainerProps {
  receiveError: (error: ResponseError) => void;
  selectedDooNumber: string;
  forceUpdate: boolean;
  resetForceUpdate: () => void;
  openModalManualEntry: () => void;
  history: History;
  openCloseEditAwbs: Function;
};

interface ManagedExportRightSideContainerState {
  doo: PickupOrderGha;
};

class ManagedExportRightSideContainer extends Component<ManagedExportRightSideContainerProps, ManagedExportRightSideContainerState> {

  state: ManagedExportRightSideContainerState = {
    doo: PO_SCHEMA_GHA
  };

  componentDidMount() {
      
    if (this.props.selectedDooNumber && this.props.selectedDooNumber !== '-1') {

      this.loadDropOffOrderAwbs(this.props.selectedDooNumber);
    }
  }

  componentDidUpdate(prevProps: ManagedExportRightSideContainerProps) {
    
    if (this.props.selectedDooNumber !== prevProps.selectedDooNumber && this.props.selectedDooNumber !== '-1' || this.props.forceUpdate) {

      this.props.resetForceUpdate();
      this.loadDropOffOrderAwbs(this.props.selectedDooNumber);
    }

    if (this.props.selectedDooNumber !== prevProps.selectedDooNumber && this.props.selectedDooNumber === '-1') {
      
      this.setState({ doo: PO_SCHEMA_GHA });
    }
  }

  loadDropOffOrderAwbs = (dooNumber: string): void => {

    pickupOrderRemote.getGhaPickupOrderList(dooNumber).then((resp: ApiResponse<PickupOrderGha>) => {

      const doo: PickupOrderGha | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (doo) {
        this.setState({ doo });
      }
      
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  render () {

    if (this.state.doo.number !== '') {

      return (
        <Fragment>
          <TruckerRecordInfoContainer
            truckerInfo={{
              driverName: this.state.doo.driver_name,
              driverId: this.state.doo.driver_id,
              maskedDriverId: (this.state.doo.driver_id) ? this.state.doo.driver_id.replace(/.(?=.{4,}$)/g, '#') : this.state.doo.driver_id,
              driverIDType: this.state.doo.driver_id_type,
              matchingPhoto: this.state.doo.matching_photo
            }}
            selectedDooNumber={ this.props.selectedDooNumber }
            disabled={ this.state.doo.allowed_ops.update_dispatch_driver_details }
          />
          <SecurityDetailsContainer 
            dropOffOrder={ this.state.doo }
            selectedDooNumber={ this.props.selectedDooNumber }
          />
          <DooAwbListContainer 
            awbs={ this.state.doo.list } 
            selectedDooNumber={ this.props.selectedDooNumber } 
            loadListAwbs={ this.loadDropOffOrderAwbs }
            openModalManualEntry={ this.props.openModalManualEntry }
            doo={this.state.doo}
            history={ this.props.history }
          />
        </Fragment>
      );
    }

    return null;
  }
}

const mapStateToProps = (state: any) => {
  return {
    forceUpdate: state.updateManagedExportRightSideContainer
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    resetForceUpdate: () => dispatch(stopUpdate())
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(ManagedExportRightSideContainer);